import Vue from 'Vue';

/**
 * ********************************************************************
 * standard import lines for every component. Importing the template
 * and the component specific style.
 * ********************************************************************
 */
import './dc-topbar.style.scss';
import template from './dc-topbar.template.htm';
/**
 * *********************************************************************
 */

export default Vue.component('dc-topbar', {
    template: template,
    props: {},
    data() {
        return {

        };
    },
    computed: {
        categories(){
            return this.$store.getters.categories;
        }
    },
    created() {},
    mounted() {},
    methods: {},
    watch: {}
});